import type { SizeType } from 'antd/es/config-provider/SizeContext';

export const ComponentSize = {
  SMALL: 'small' as SizeType,
  MEDIUM: 'medium' as SizeType,
  LARGE: 'large' as SizeType,
};

export type ComponentSizeType =
  (typeof ComponentSize)[keyof typeof ComponentSize];
